import { handleError } from '../../../redux/actions/common-message/message-action';
import { makeApiCall } from '../../../redux/actions/common/common-action';
import { API_URL } from '../../../utils/config';
import { ADDRESS_ARRAY } from './constants';

export const updateBeneAdditionalInfo = (data: any | any, beneficiaryID: number) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const payload = new FormData();
      Object.keys(data || {})?.map((key) => payload.append(key, data[key]));
      const response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/beneficiary/${beneficiaryID}/additional-info`,
        data: payload,
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
    return { success: false };
  };
};

export const getAddressData = () => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/remitter/individual`,
        method: 'get',
        withCredentials: true
      });
      if (response?.data?.success) {
        const remitterDetails = response.data?.data?.remitterDetails;
        const addressKeyValues = ADDRESS_ARRAY.reduce(
          (acc: { [key: string]: string | null }, curr: string) => {
            acc[curr] = remitterDetails[curr];
            return acc;
          },
          {}
        );
        return addressKeyValues;
      }
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};
